// removed by extract-text-webpack-plugin
module.exports = {"Email":"Email--aPkv2","EmailAddress":"EmailAddress--jQfug","addEmail":"addEmail--1L6sR"};